webpackJsonp([116279477833565],{

/***/ 1860:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MedicationStatusCount","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":"Number of medications with this status","isDeprecated":false,"name":"count","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}},{"args":[],"deprecationReason":null,"description":"The pharmacy status","isDeprecated":false,"name":"pharmacyStatus","type":{"kind":"ENUM","name":"PharmacyStatus","ofType":null}},{"args":[],"deprecationReason":null,"description":"The medication status","isDeprecated":false,"name":"status","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"MedicationStatus","ofType":null}}}],"description":"Count of medications grouped by status","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-medication-status-count-60d76cb77e6807d21c13.js